import { CondizioneModel } from "../models/CondizioneModel";
import { ContrattoModel } from "../models/ContrattoModel";
import { PersonaFisicaModel } from "../models/PersonaFisicaModel";
import { BeneSottoTipologiaModel } from "../models/api/response/bene/BeneSottoTipologiaModel";
import { FetchPaginatedApiModel } from "../models/shared/CommonModels";
import { api_url } from "../utils/ApiContext";
import { getRequest } from "./apiCommon";

const baseUrl = api_url.concat("/api/dashboard-filter");

const fetchCustomers = async (searchTerm: string | undefined) => {
  let completeUrl = new URL(baseUrl.concat("/customers"));
  const params = completeUrl.searchParams;

  if (searchTerm !== undefined && searchTerm !== "") {
    params.set("search_term", searchTerm);
  }

  return (
    await getRequest<FetchPaginatedApiModel<PersonaFisicaModel[]>>(
      completeUrl.toString()
    )
  ).data;
};

const fetchContracts = async (
  searchTerm: string | undefined,
  customerId: string | undefined
) => {
  let completeUrl = new URL(baseUrl.concat("/contracts"));
  const params = completeUrl.searchParams;

  if (searchTerm !== undefined && searchTerm !== "") {
    params.set("search_term", searchTerm);
  }
  if (customerId !== undefined && customerId !== "") {
    params.set("id_cliente", customerId);
  }

  return (
    await getRequest<FetchPaginatedApiModel<ContrattoModel[]>>(
      completeUrl.toString()
    )
  ).data;
};

const fetchGoodSubCategories = async (
  searchTerm: string | undefined,
  customerId: string | undefined,
  contractId: string | undefined,
  goodConditionId: string | undefined
) => {
  let completeUrl = new URL(baseUrl.concat("/good-sub-categories"));
  const params = completeUrl.searchParams;

  if (searchTerm !== undefined && searchTerm !== "") {
    params.set("search_term", searchTerm);
  }
  if (customerId !== undefined && customerId !== "") {
    params.set("id_cliente", customerId);
  }
  if (contractId !== undefined && contractId !== "") {
    params.set("id_contratto", contractId);
  }
  if (goodConditionId !== undefined && goodConditionId !== "") {
    params.set("id_condizione_bene", goodConditionId);
  }

  return (
    await getRequest<FetchPaginatedApiModel<BeneSottoTipologiaModel[]>>(
      completeUrl.toString()
    )
  ).data;
};

const fetchGoodCondition = async (
  searchTerm: string | undefined,
  customerId: string | undefined,
  contractId: string | undefined,
  goodSubCategoryId: string | undefined
) => {
  let completeUrl = new URL(baseUrl.concat("/good-condition"));
  const params = completeUrl.searchParams;

  if (searchTerm !== undefined && searchTerm !== "") {
    params.set("search_term", searchTerm);
  }
  if (customerId !== undefined && customerId !== "") {
    params.set("id_cliente", customerId);
  }
  if (contractId !== undefined && contractId !== "") {
    params.set("id_contratto", contractId);
  }
  if (goodSubCategoryId !== undefined && goodSubCategoryId !== "") {
    params.set("id_sotto_tipologia_bene", goodSubCategoryId);
  }

  return (
    await getRequest<FetchPaginatedApiModel<CondizioneModel[]>>(
      completeUrl.toString()
    )
  ).data;
};

export {
  fetchCustomers,
  fetchContracts,
  fetchGoodSubCategories,
  fetchGoodCondition,
};
